import { render, staticRenderFns } from "./TermsRegistration.vue?vue&type=template&id=24ea1502&scoped=true"
import script from "./TermsRegistration.vue?vue&type=script&lang=js"
export * from "./TermsRegistration.vue?vue&type=script&lang=js"
import style0 from "./TermsRegistration.vue?vue&type=style&index=0&id=24ea1502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea1502",
  null
  
)

export default component.exports